import type { Context } from '@/lib/store/ui';

/**
 * ENG-282 hid the right-hand Events / Alerts / AI Intelligence panel for the
 * ArduPilot conference. ENG-340 brings the sidebar back, but only for the
 * Drones and OIs contexts and with two new tabs: DAA Alerts and Airband Radio.
 * Nothing was deleted: the old three tabs are still in `RightPanel` behind
 * `LEGACY_PANEL_TABS`. The Debug Logs tab shows in debug mode in any context.
 * Alecia is redesigning this area in Nov/Dec.
 */
export const RIGHT_PANEL_ENABLED = true;

/** Contexts that get the sidebar. */
export const RIGHT_PANEL_CONTEXTS: readonly Context[] = ['drones', 'oi'];

/** Set to `true` to bring back Events / Alerts / AI Intelligence (ENG-282). */
export const LEGACY_PANEL_TABS = false;

export const rightPanelShownIn = (ctx: Context): boolean =>
  RIGHT_PANEL_ENABLED && RIGHT_PANEL_CONTEXTS.includes(ctx);
